import React, {} from "react";
import { connect } from 'react-redux';
import { Grid } from '@material-ui/core';
import ImportadorBudgetForecastDos from "../../../components/Indicadores/Personalizados/Tenacta/ImportadorDos/ImportadorBudgetForecastDos";

const ImportacionDos = (props) => {
  const { ejecucionDePagina } = props;

  return (
    <Grid container spacing={1}>
      <Grid item xs={12}>
        <ImportadorBudgetForecastDos ejecucionDePagina={ejecucionDePagina} />
      </Grid>
    </Grid>
  )
}

const mapStateToProps = (state) => {
  return {};
};

const mapDispatchToProps = (dispatch) => {
  return {};
};

export default connect(mapStateToProps, mapDispatchToProps)(ImportacionDos);